module.exports = __webpack_public_path__ + "img/logo-icon-square-192.ece6e2d7.png";